import { Button, Modal, Spin } from "antd";
import styled from "styled-components";

import { useGlobalContext } from "../../context/GlobalContext";

import useGet from "../common/useGet";
import { useEffect } from "react";

export const USSDHealthCheck = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openUSSDHealthCheck } = globalData || {};

  const {
    loadData: checkUSSDHealthCheck,
    loading: checkingUSSDHealthCheck,
    data: USSDHealthCheckData,
  } = useGet();

  const handleClose = () => {
    updateData({ openUSSDHealthCheck: false });
  };

  // Check for USSD Health when modal opens
  useEffect(() => {
    if (openUSSDHealthCheck) {
      checkUSSDHealthCheck({ api: "ussdreports/ussd-health-check" });
    }
  }, [openUSSDHealthCheck]);

  return (
    <Modal
      open={!!openUSSDHealthCheck}
      onCancel={handleClose}
      title={
        USSDHealthCheckData
          ? "USSD Service Health Overview"
          : "No USSD Health Check Data"
      }
      footer={null}
      centered
      width={500}
    >
      {checkingUSSDHealthCheck || !USSDHealthCheckData ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin size="large" />
          <p style={{ marginTop: 16, color: "#8c8c8c" }}>
            Checking USSD Health...
          </p>
        </div>
      ) : (
        <USSDHealthCheckModalContent>
          <h3
            style={{ color: "#1a75ba", fontWeight: "bold", fontSize: "1.5rem" }}
          >
            USSD Health Check
          </h3>

          <p
            style={{
              textAlign: "center",
              fontSize: "1.1rem",
              color: "#64748b",
            }}
          >
            <strong>Overall Status:</strong>
            <span style={{ color: "#16a34a", fontWeight: "bold" }}>
              {" "}
              {USSDHealthCheckData?.overall_status}
            </span>{" "}
            ✅
          </p>
          <p
            style={{
              textAlign: "center",
              color: "#475569",
              marginBottom: "2rem",
            }}
          >
            Accessibility: {USSDHealthCheckData?.accessibility}
          </p>

          <USSDHealthCheckDataContent>
            {USSDHealthCheckData?.processes ? (
              USSDHealthCheckData.processes.map((item: any, index: number) => (
                <div key={index}>
                  <USSDHealthCheckDataContainer>
                    <strong>{item.Name}</strong>
                    <br />
                    <span style={{ color: "#16a34a", fontWeight: "bold" }}>
                      {item.Status}
                    </span>{" "}
                    – {item.Message}
                  </USSDHealthCheckDataContainer>
                </div>
              ))
            ) : (
              <p>No USSD Health Check Data</p>
            )}
          </USSDHealthCheckDataContent>

          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              marginTop: 24,
            }}
          >
            <Button onClick={handleClose} size="large">
              Close
            </Button>
          </div>
        </USSDHealthCheckModalContent>
      )}
    </Modal>
  );
};

// Styled Components for QR Code Modal
const USSDHealthCheckModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  text-align: center;

  h3 {
    margin-bottom: 20px;
    color: #262626;
    font-size: 18px;
  }

  p {
    color: #595959;
  }
`;

const USSDHealthCheckDataContent = styled.p`
  display: grid;
  gap: 1rem;
`;
const USSDHealthCheckDataContainer = styled.div`
  background: white;
  padding: 1.2rem;
  border-radius: 12px;
  border-left: 5px solid #16a34a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;
